import React,{useState} from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png"
import icon1 from "../../assets/images/icon1.png"
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import icrageeLogo from "../../assets/images/icragee.png"
import Footer from "../../components/Footer/Footer";
import venueImage from "../../assets/images/venue.png"
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg"
import mapImage from "../../assets/images/map.png"
import Navbar from "../../components/Navbar/Navbar"
import Layout from "../../components/Layout/layout";
const AboutIITR = () => {
    
    return(
        <Layout>
        <main className="bg-gray-100">
           
      <div className="flex justify-center">
      <div className="flex absolute md:mt-[-10vw] mt-[-35vw] md:flex-row flex-col items-center w-full justify-center gap-12">
        <div className="text-[55px] text-white" 
            style={{fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000'}}
            >
                ABOUT DEPT. OF EARTHQUAKE ENG., IIT ROORKEE
            </div>
        </div>
      <div className="w-full md:w-3/4 px-10 md:px-20 py-32 border-y my-10 bg-white text-justify">
            <div className="font-bold text-2xl md:text-5xl text-sky-800 mb-10">
                DEPT. of EARTHQUAKE ENG., IIT Roorkee
            </div>
            <div className="text-xl md:text-3xl mb-4">
            Dept. of Earthquake Engineering at IIT Roorkee was established in 1960 as the School of Research and Training in Earthquake Engineering. The department provides master’s degree in three specializations, namely Structural Dynamics, Soil Dynamics and Seismic Vulnerability and Risk Assessment. Also, it provides PhDs in all disciplines of Earthquake Engineering. It renders expert advice to various organizations in the area of earthquake resistance design of structures and foundations, site-specific parameter studies. It plays a key role at national and international level for earthquake engineering.
            </div>
            <div className="text-xl md:text-3xl text-blue-500 text-underline"><a href="https://iitr.ac.in/Departments/Earthquake%20Department/Home.html">Click here to visit the website</a></div>

        </div>
        
      </div>
      
        </main>
        </Layout>
    );
}
export default AboutIITR;